import { Element } from "@xmpp/xml"
import { DataFormsParser } from "@/lib/formParser"
import { GpsConfig } from "@/reducers/gpsConfigSlice"

class GpsConfigParser {
  static parseItem(item: Element): GpsConfig {
    if (!item.attrs.id) {
      throw new Error("GPS config item missing required id attribute")
    }

    const form = DataFormsParser.parse(item)
    const driverId = form?.fields?.["driver_id"]?.values?.[0]
    const deviceId = form?.fields?.["device_id"]?.values?.[0]

    return {
      driverJid: item.attrs.id,
      driverId: driverId || "",
      deviceId: deviceId || "",
    }
  }

  static parse(stanza: Element): GpsConfig | undefined {
    const eventNode =
      stanza.getChild("event", "http://jabber.org/protocol/pubsub#event") ||
      stanza.getChild("pubsub", "http://jabber.org/protocol/pubsub")
    if (!eventNode) return

    const itemsNode = eventNode.getChildByAttr("node", "gps_config")
    if (!itemsNode) return

    const itemNode = itemsNode.getChildren("item")[0]
    if (!itemNode) return

    return GpsConfigParser.parseItem(itemNode)
  }
}

export default GpsConfigParser
